import {
  cancellationPlan,
  CancellationPlanType
} from "@website/accommodation-ui/villa-reserve-cancellation-policies";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { FC, useMemo } from "react";

export const TabPanel: FC<{
  cancellationPlanType: CancellationPlanType;
  cancellationRules: string;
}> = ({ cancellationPlanType, cancellationRules }) => {
  const cancellationPlanTypeTitle = cancellationPlan[cancellationPlanType];

  const replacedRules = useMemo(
    () =>
      replaceSnappTripBasedOnChannel(cancellationRules)
        .replaceAll(".", ".\n")
        ?.split("\n"),
    [cancellationRules]
  );
  return (
    <div className="flex flex-col gap-4">
      {cancellationPlanTypeTitle ? (
        <p className="text-on-surface-high-emphasis pt-2 font-bold">
          <span>قوانین این اقامتگاه </span>
          <span className="text-secondary">{cancellationPlanTypeTitle} </span>
          <span>است</span>
        </p>
      ) : null}
      <div className="text-sm">
        {replacedRules.map((p) => (
          <div>{p}</div>
        ))}
      </div>
    </div>
  );
};
